import { ShieldCheck, Target } from 'lucide-react';
import './sitewide-immersion.css';

export default function ServiceArtwork({ kind }: { kind: 'risk' | 'fractional' }) {
  return <div className={`service-sculpture service-sculpture--${kind}`} aria-hidden="true">
    <div className="service-sculpture__light" />
    {kind === 'risk' ? <div className="risk-sculpture">
      <div className="risk-sculpture__base" />
      <div className="risk-sculpture__sheet"><Target strokeWidth={.7} /><div className="risk-sculpture__rules"><i /><i /><i /><i /></div></div>
      <div className="risk-sculpture__evidence risk-sculpture__evidence--one"><i /><i /><i /></div>
      <div className="risk-sculpture__evidence risk-sculpture__evidence--two"><i /><i /><i /></div>
      <div className="risk-sculpture__evidence risk-sculpture__evidence--three"><i /><i /><i /></div>
    </div> : <div className="leadership-sculpture">
      <div className="leadership-sculpture__floor" />
      <div className="leadership-sculpture__pillar"><i /></div>
      <div className="leadership-sculpture__pillar"><i /></div>
      <div className="leadership-sculpture__pillar"><i /></div>
      <div className="leadership-sculpture__pillar"><i /></div>
      <div className="leadership-sculpture__beam"><ShieldCheck strokeWidth={.65} /><i /><i /></div>
      <div className="leadership-sculpture__cap" />
    </div>}
    <div className="service-sculpture__ground" />
  </div>;
}
